/**
 * index.js
 * Main entry point and routing for Data-Next app
 */

import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { TeamProvider } from "./context/TeamContext";
import TeamAccessWrapper from "./components/TeamAccessWrapper";
import Sidebar from "./components/Sidebar";

// Import pages
import Dashboard from "./pages/Dashboard";
import ContextLibrary from "./pages/ContextLibrary";
import Agents from "./pages/Agents";
import FlowchartAgent from "./pages/FlowchartAgent";
import AgentHistory from "./pages/AgentHistory";
import TeamSettings from "./pages/TeamSettings";
import VSCodeAuth from "./pages/VSCodeAuth";

// Import styles
import "./styles/data-next.css";

export default function DataNextRoutes() {
  return (
    <TeamProvider>
      <Routes>
        {/* VS Code Extension Auth Route (no TeamAccessWrapper, no Sidebar) */}
        <Route path="/auth/vscode" element={<VSCodeAuth />} />
        
        {/* Normal routes with authentication and sidebar */}
        <Route
          path="/*"
          element={
            <TeamAccessWrapper>
              <div className="data-next-layout">
                <Sidebar />
                <div className="data-next-main">
                  <Routes>
                    <Route
                      path="/"
                      element={<Navigate to="/data-next/dashboard" replace />}
                    />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/context-library" element={<ContextLibrary />} />
                    <Route path="/agents" element={<Agents />} />
                    <Route path="/agents/flowchart" element={<FlowchartAgent />} />
                    <Route
                      path="/agents/flowchart/:executionId"
                      element={<FlowchartAgent />}
                    />
                    <Route path="/history" element={<AgentHistory />} />
                    <Route path="/team-settings" element={<TeamSettings />} />
                  </Routes>
                </div>
              </div>
            </TeamAccessWrapper>
          }
        />
      </Routes>
    </TeamProvider>
  );
}
